export default {
    smallDevices: 400,
    mediumDevices: 768,
    largeDevices: 992,
    extraLargeDevices: 1400 
}
